import { ReactNode, createContext, useContext, useMemo } from "react";
import { useComplexState } from "use-complex-state";
import { MechanicalByHeatReducer } from "./MechanicalByHeatReducer";

const MechanicalByHeatContext = createContext({
	state: MechanicalByHeatReducer.getInitialState(),
	actions: MechanicalByHeatReducer.actions,
});

export const useMechanicalByHeatContext = () =>
	useContext(MechanicalByHeatContext);

export const MechanicalByHeatProvider = ({
	children,
}: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: MechanicalByHeatReducer.getInitialState(),
		reducers: MechanicalByHeatReducer.caseReducers,
	});

	// Remove 'actions' from dependencies - it changes every render but doesn't need to trigger updates
	const value = useMemo(() => ({ state, actions }), [state]);

	return (
		<MechanicalByHeatContext.Provider value={value}>
			{children}
		</MechanicalByHeatContext.Provider>
	);
};
